<template>
  <div class="auth-wrapper-provider">
    <AuthWrapper :showLogo="false">
      <template #main>
        <b-row>
          <b-col cols="12" md="12" class="text-center margin-bottom-40">
            <b-img
              :src="$config.images.shared.redesign.empty.resultRegistrations"
              width="150"
            />
          </b-col>
          <b-col cols="12" md="12" class="margin-bottom-24">
            <div
              class="font-size-16 color-complementary-400 text-center margin-bottom-8"
            >
              {{ $lang.successfully_registration }}
            </div>
            <div
              class="font-size-14 color-complementary-300 text-center"
              v-html="renderMessage"
            ></div>
          </b-col>
          <b-col cols="12" md="12" class="text-center">
            <Button
              class="width-percent-100"
              contentClass="justify-content-center"
              variant="primary"
              :text="$lang.login_to_system"
              @click="goToAuth"
            />
          </b-col>
        </b-row>
      </template>
    </AuthWrapper>
  </div>
</template>

<script>
import { AuthWrapper } from "@/components/re-design";
import { Button } from "@/components/re-design/forms";
import { mapGetters } from "vuex";
import { pathOr } from "ramda";
import { goToRoute } from "@/shared/utils";

export default {
  components: {
    AuthWrapper,
    Button,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("auth", ["parvandehInfo"]),
    linkCaption() {
      return pathOr("", ["link_caption"], this.parvandehInfo);
    },
    renderMessage() {
      const linkCaption = pathOr("", ["link_caption"], this.parvandehInfo);
      const preRegisterResultSupportText = this.$lang
        .pre_register_result_support_text
        ? `<span><mdicon name='phone' size='24' class='margin-left-10' /></i> ${this.$lang.pre_register_result_support_text}</span>`
        : "";
      const userStateMessages = {
        current_user: `با توجه به داشتن نام کاربری و رمز عبور در سامانه، جهت ورود روی دکمه ورود به سامانه کلیک کنید.<br />
        ${preRegisterResultSupportText}`,
        new_user: `اطلاعات کاربری برای شما پیامک شد،
        جهت انجام ثبت نام در <b>"${linkCaption}"</b> روی دکمه ورود به سامانه کلیک کنید و با اطلاعات کاربری خود در سامانه وارد شوید.<br />
        ${preRegisterResultSupportText}`,
      };
      const userState = pathOr("new_user", ["user_state"], this.parvandehInfo);
      return userStateMessages[userState];
    },
  },
  created() {
    this.checkParvandehInfo();
  },
  methods: {
    pathOr,
    goToRoute,
    goToAuth() {
      goToRoute("auth", {}, {}, false);
    },
    checkParvandehInfo() {
      // check exist parvandeh info
      if (!Object.keys(this.parvandehInfo).length) {
        this.$notify.warning(this.$lang.notExistParvandehInfoMessage);
        return goToRoute("active-registrations", {}, {}, false);
      }
    },
  },
};
</script>
